/* cdu-collection.js (3 Nov 2026). Collection and search pages.
   Car header, second image on hover, quick add with an option picker, active filter chips with clear all,
   sticky bar offset, phone filter sheet, loading skeletons.
   It reuses CDSBC.car, CDSBC.fit and the cdu-components layers. It adds no fit or query rule of its own. */
(function () {
  'use strict';
  var CDU = window.CDU = window.CDU || {};
  var doc = document, html = doc.documentElement;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var CFG = {}; try { CFG = JSON.parse($('#cdx-cfg').textContent); } catch (e) {}
  var fmt, fmt0;
  try { fmt = new Intl.NumberFormat(CFG.loc || 'en-IE', { style: 'currency', currency: CFG.cur || 'EUR' }); fmt0 = new Intl.NumberFormat(CFG.loc || 'en-IE', { style: 'currency', currency: CFG.cur || 'EUR', maximumFractionDigits: 0 }); }
  catch (e) { fmt = new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR' }); fmt0 = new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }); }
  var money = function (c) { return fmt.format((+c || 0) / 100); };
  var phone = function () { return matchMedia('(max-width:860px)').matches; };
  var root = $('.cdx-shop') || $('#cdx-search');

  /* ---------- the saved car and how a car is written ---------- */
  function saved() {
    var s = null; try { s = JSON.parse(localStorage.getItem('cdx-car') || 'null'); } catch (e) {}
    return s && window.CDSBC ? CDSBC.car(s.u) : null;
  }
  /* "BMW M3, 2014 to 2018". Years come from the car index. A code with no year is never shown. */
  function carText(c) {
    if (!c) return null;
    var gt = String(c.gt || ''), m = gt.match(/(\d{4})\s*(?:[-–]\s*(\d{4})|(\+))?/), body = '', years = '';
    if (m) {
      body = gt.replace(m[0], '').replace(/\s+/g, ' ').trim();
      years = m[2] ? m[1] + ' to ' + m[2] : m[3] ? m[1] + ' onwards' : m[1];
    }
    var name = (c.mk + ' ' + c.name + (body ? ' ' + body : '')).trim();
    return { name: name, years: years, text: name + (years ? ', ' + years : ''), short: c.short || c.name, car: c };
  }
  CDU.carText = carText;

  /* ---------- car header ---------- */
  var head = $('#cdu-carhead');
  function renderHead() {
    if (!head || !window.CDSBC) return;
    var view = CDSBC.car(head.getAttribute('data-col')), mine = saved(), v = carText(view), m = carText(mine);
    var eyebrow, car, sub, btns = '', links = '';
    var chg = '<button type="button" class="cdu-carhead__chg" data-open-garage>Change car</button>';
    if (v) {
      var same = mine && mine.u === view.u;
      eyebrow = same ? 'Showing parts for your car' : 'Showing parts for';
      car = esc(v.name) + (v.years ? ', <span class="cdu-carhead__yrs">' + esc(v.years) + '</span>' : '');
      if (same) { sub = 'Your car. Every part here is listed for it.'; links = chg; }
      else if (mine) {
        sub = 'Your car is the ' + esc(m.text) + '.';
        btns = '<a class="btn" href="' + esc(mine.u) + '">Parts for my ' + esc(m.short) + '</a>';
        links = '<button type="button" class="cdu-carhead__chg" data-save-car="' + esc(view.u) + '">Make this my car</button>' + chg;
      } else {
        sub = 'Save it and every part shows if it fits.';
        btns = '<button type="button" class="btn btn--ghost" data-save-car="' + esc(view.u) + '">Save as my car</button>';
        links = chg;
      }
    } else if (mine) {
      eyebrow = 'Your car'; car = esc(m.name) + (m.years ? ', <span class="cdu-carhead__yrs">' + esc(m.years) + '</span>' : '');
      sub = 'See only the parts listed for it.';
      btns = '<a class="btn btn--ghost" href="' + esc(mine.u) + '">Only parts for my car</a>'; links = chg;
    } else {
      eyebrow = 'Find parts that fit'; car = 'Add your car'; sub = 'Every part then shows if it fits.';
      btns = '<button type="button" class="btn btn--ghost" data-open-garage>Add my car</button>';
    }
    var next = '<div class="cdu-carhead__main"><span class="cdu-carhead__eyebrow">' + eyebrow + '</span><h2 class="cdu-carhead__car">' + car + '</h2><p class="cdu-carhead__sub">' + sub + '</p></div>'
      + '<div class="cdu-carhead__acts">' + btns + (links ? '<div class="cdu-carhead__links">' + links + '</div>' : '') + '</div>';
    if (head.getAttribute('data-sig') !== next) { head.innerHTML = next; head.setAttribute('data-sig', next); }
  }

  /* ---------- second image on hover, white backgrounds only ---------- */
  var seen = {};
  function whiteShot(src) {
    return seen[src] || (seen[src] = new Promise(function (res) {
      var im = new Image();
      im.onload = function () {
        try {
          var s = 48, cv = doc.createElement('canvas'); cv.width = cv.height = s;
          var cx = cv.getContext('2d', { willReadFrequently: true }); cx.drawImage(im, 0, 0, s, s);
          var d = cx.getImageData(0, 0, s, s).data, tot = 0, w = 0, b = 3;
          for (var y = 0; y < s; y++) for (var x = 0; x < s; x++) {
            if (x >= b && x < s - b && y >= b && y < s - b) continue;
            var i = (y * s + x) * 4; tot++;
            if (d[i + 3] > 200 && d[i] >= 238 && d[i + 1] >= 238 && d[i + 2] >= 238) w++;
          }
          res(w / tot >= 0.88);
        } catch (e) { res(false); }
      };
      im.onerror = function () { res(false); };
      im.src = src;
    }));
  }
  function prepHover(a) {
    if (!a || a.getAttribute('data-cdu-img2')) return;
    var src = a.getAttribute('data-img2'); if (!src) return;
    a.setAttribute('data-cdu-img2', 'load');
    whiteShot(src).then(function (ok) {
      if (!ok) { a.setAttribute('data-cdu-img2', 'skip'); return; }
      var i = new Image(); i.className = 'card__img2'; i.alt = ''; i.decoding = 'async'; i.setAttribute('aria-hidden', 'true'); i.src = src;
      a.appendChild(i); a.setAttribute('data-cdu-img2', 'ready');
    });
  }
  if (matchMedia('(hover:hover)').matches) {
    doc.addEventListener('mouseover', function (e) { var a = e.target.closest && e.target.closest('.card__img'); if (a) prepHover(a); }, { passive: true });
    doc.addEventListener('focusin', function (e) { var c = e.target.closest && e.target.closest('.card'); if (c) prepHover($('.card__img', c)); });
  }

  /* ---------- quick add ---------- */
  function wa(text) { return 'https://wa.me/353834080320?text=' + encodeURIComponent(text); }
  function cardTitle(card) { var i = $('.card__img img', card); return (i && i.alt) || ($('.card__title', card) || {}).textContent || 'this part'; }
  function node(h) { var d = doc.createElement('div'); d.innerHTML = h; return d; }

  /* a part that is not confirmed for the saved car asks first. The default action is to open the part. */
  function fitGate(card, btn, mine, f) {
    var m = carText(mine), href = $('.card__img', card).getAttribute('href');
    var why = f === 'no' ? 'This part is listed for a different car. Open it to see which cars it fits, or add it anyway.' : 'We have not confirmed this part for your car yet. Ask us before you order, or add it anyway.';
    var body = node('<p>' + why + '</p><p class="cdu-vpick__msg"><a href="' + wa('Hi Carbon District, does ' + cardTitle(card) + ' fit my ' + m.text + '?') + '" target="_blank" rel="noopener">Ask us on WhatsApp</a></p>');
    var foot = node('<div style="display:contents"><a class="btn" href="' + esc(href) + '" data-cdu-autofocus>View this part</a><button type="button" class="btn btn--ghost" data-add="' + esc(btn.getAttribute('data-add')) + '">Add anyway</button></div>');
    var fnode = foot.firstChild, anyway = fnode.querySelector('[data-add]');
    var inst = CDU.modal.create({ title: f === 'no' ? 'Not listed for your ' + m.name : 'Fit not confirmed for your ' + m.name, content: body, footer: fnode, size: 'sm', remove: true });
    inst.el.classList.add('cdu-gate');
    anyway.addEventListener('click', function () { inst.close(); });
  }

  /* a part with options opens its choices here, then adds the chosen one */
  function picker(card, link) {
    var href = link.getAttribute('href').split('?')[0];
    link.setAttribute('aria-busy', 'true');
    fetch(href + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
      var vs = (p.variants || []).slice(); if (!vs.length) throw 0;
      var pick = vs.filter(function (x) { return x.available; }).sort(function (a, b) { return a.price - b.price; })[0] || vs[0];
      var img = $('.card__img img', card), mine = saved(), f = mine ? CDSBC.fit(mine.u, card.dataset.cols, card.dataset.model) : null;
      var note = '';
      if (mine && f) { var m = carText(mine); note = f === 'yes' ? '<p class="cdu-vpick__note"><b>Listed for your ' + esc(m.name) + '.</b> We confirm the exact fit with your year before it is made.</p>' : '<p class="cdu-vpick__note"><b>' + (f === 'no' ? 'Not listed for your ' : 'Not confirmed for your ') + esc(m.name) + '.</b> <a href="' + esc(href) + '" style="color:#fff;text-decoration:underline">Open the part</a> to check before you add it.</p>'; }
      var rows = vs.map(function (x) {
        return '<label class="cdu-vopt"><input type="radio" name="cdu-v" value="' + x.id + '"' + (x.id === pick.id ? ' checked' : '') + '><span class="cdu-vopt__t">' + esc(x.title) + '</span><span class="cdu-vopt__p">' + money(x.price) + '</span></label>';
      }).join('');
      var body = node('<div class="cdu-vpick"><div class="cdu-vpick__hd">' + (img ? '<img src="' + esc(img.currentSrc || img.src) + '" alt="" width="72" height="72">' : '') + '<div><span class="label">' + esc(($('.card__make', card) || {}).textContent || '') + '</span><b>' + esc(p.title) + '</b></div></div>' + note + '<fieldset class="cdu-vpick__opts"><legend class="cdu-sr">Choose an option</legend>' + rows + '</fieldset></div>');
      var foot = node('<div style="display:contents"><button type="button" class="btn" data-add="' + pick.id + '" data-cdu-autofocus>Add to basket</button><a class="btn btn--ghost" href="' + esc(href) + '">View details</a></div>');
      var add = foot.firstChild.querySelector('[data-add]');
      body.addEventListener('change', function (e) { if (e.target.name === 'cdu-v') add.setAttribute('data-add', e.target.value); });
      var inst = CDU.drawer.create({ title: 'Choose an option', side: phone() ? 'bottom' : 'right', content: body.firstChild, footer: foot.firstChild, remove: true, opener: link });
      inst.el.classList.add('cdu-pick');
      add.addEventListener('click', function () { inst.close(); });
    }).catch(function () { location.href = link.href; }).then(function () { link.removeAttribute('aria-busy'); });
  }

  doc.addEventListener('click', function (e) {
    if (!root || !CDU.modal || !CDU.drawer) return;
    var t = e.target.closest && e.target.closest('.card__add'); if (!t) return;
    var card = t.closest('.card'); if (!card) return;
    if (t.tagName === 'A') {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
      e.preventDefault(); e.stopPropagation(); picker(card, t); return;
    }
    var mine = saved(); if (!mine) return;
    var f = CDSBC.fit(mine.u, card.dataset.cols, card.dataset.model);
    if (f === 'yes') return;
    e.preventDefault(); e.stopPropagation(); fitGate(card, t, mine, f);
  }, true);

  /* ---------- filters: chips with clear all, count on the button ---------- */
  var priceApplied = '';
  function priceLabel() {
    var pf = $('#b-price'); if (!pf) return '';
    var i = $$('input[type=number]', pf), lo = i[0] && i[0].value, hi = i[1] && i[1].value;
    if (lo && hi) return fmt0.format(+lo) + ' to ' + fmt0.format(+hi);
    if (lo) return 'From ' + fmt0.format(+lo);
    if (hi) return 'Up to ' + fmt0.format(+hi);
    return '';
  }
  function chipText(c) { var k = c.cloneNode(true); $$('small', k).forEach(function (s) { s.remove(); }); return k.textContent.replace(/\s+/g, ' ').trim(); }
  function readActive() {
    var out = [], cp = $('#c-part'), pf = $('#b-price'), bc = $('#b-car');
    if (cp) {
      var all = cp.querySelector('.chip');
      $$('.chip[aria-pressed="true"]', cp).forEach(function (c) { if (c === all) return; out.push({ label: chipText(c), clear: function () { var a = cp.querySelector('.chip'); a && a.click(); } }); });
    }
    if (priceApplied) out.push({ label: priceApplied, clear: function () {
      var i = $$('input[type=number]', pf); i.forEach(function (x) { x.value = ''; });
      if (root.classList.contains('was-car')) pf.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      else pf.requestSubmit ? pf.requestSubmit() : pf.submit();
    } });
    if (bc) {
      var cc = $('[data-car-chip][aria-pressed="true"]', bc);
      if (cc && cc.getAttribute('data-car-chip')) out.push({ label: chipText(cc), clear: function () { var a = $('[data-car-chip=""]', bc); a && a.click(); } });
    }
    return out;
  }
  var list = [];
  function renderActive() {
    var box = $('#cdu-active'); if (!box) return;
    list = readActive();
    var fb = $('#fbtn');
    var next = list.length ? list.map(function (a, i) { return '<button type="button" class="cdu-fchip" data-i="' + i + '" aria-label="Remove filter: ' + esc(a.label) + '">' + esc(a.label) + '<span class="cdu-fchip__x" aria-hidden="true"></span></button>'; }).join('') + '<button type="button" class="cdu-clearall" data-all>Clear all</button>' : '';
    if (box.getAttribute('data-sig') !== next) { box.innerHTML = next; box.setAttribute('data-sig', next); }
    box.hidden = !list.length;
    if (fb) { var lab = 'Filter' + (list.length ? '<span class="cdu-key" aria-label="' + list.length + ' applied"> ' + list.length + '</span>' : ''); if (fb.getAttribute('data-sig') !== lab) { fb.innerHTML = lab; fb.setAttribute('data-sig', lab); } }
    $$('[data-cdu-clear]').forEach(function (b) { b.hidden = !list.length; });
    var ap = $('[data-cdu-apply]'), n = parseInt((($('#count') || {}).textContent || ''), 10);
    if (ap) ap.textContent = isNaN(n) ? 'Show parts' : 'Show ' + n + ' part' + (n === 1 ? '' : 's');
  }
  function clearAll() {
    if (root && root.id === 'cdx-search' && !root.classList.contains('was-car') && !$('#c-part button.chip')) {
      var u = new URL(location.href), sp = u.searchParams, b = sp.get('base');
      if (b) sp.set('q', b);
      ['base', 'part', 'page'].forEach(function (k) { sp.delete(k); });
      Array.from(sp.keys()).filter(function (k) { return k.indexOf('filter.v.price') === 0; }).forEach(function (k) { sp.delete(k); });
      loading(); location.href = u.pathname + u.search; return;
    }
    list.slice().forEach(function (a) { a.clear(); });
  }
  doc.addEventListener('click', function (e) {
    var x = e.target.closest && e.target.closest('.cdu-fchip, .cdu-clearall, [data-cdu-clear]'); if (!x) return;
    e.preventDefault();
    if (x.classList.contains('cdu-fchip')) { var a = list[+x.getAttribute('data-i')]; a && a.clear(); }
    else { clearAll(); }
    if (phone()) closeSheet();
  });
  var pending = 0;
  function soon() { cancelAnimationFrame(pending); pending = requestAnimationFrame(renderActive); }

  /* ---------- the phone filter sheet ---------- */
  var fl = $('#filters'), fb = $('#fbtn'), scrim = null;
  function closeSheet() { if (fl) fl.classList.remove('open'); }
  function sheetState() {
    var on = fl.classList.contains('open');
    if (!scrim) { scrim = doc.createElement('div'); scrim.id = 'cdu-fscrim'; scrim.addEventListener('click', closeSheet); fl.parentNode.insertBefore(scrim, fl); }
    scrim.classList.toggle('is-on', on); html.classList.toggle('cdu-flock', on);
    if (fb) fb.setAttribute('aria-expanded', String(on));
    if (on) { fl.setAttribute('role', 'dialog'); fl.setAttribute('aria-modal', 'true'); fl.setAttribute('aria-label', 'Filters'); var f = $('#fclose', fl) || fl; try { f.focus({ preventScroll: true }); } catch (e) {} }
    else { fl.removeAttribute('role'); fl.removeAttribute('aria-modal'); if (doc.activeElement && fl.contains(doc.activeElement) && fb) { try { fb.focus({ preventScroll: true }); } catch (e) {} } }
  }
  if (fl) {
    new MutationObserver(sheetState).observe(fl, { attributes: true, attributeFilter: ['class'] });
    doc.addEventListener('keydown', function (e) {
      if (!fl.classList.contains('open')) return;
      if (e.key === 'Escape') { closeSheet(); return; }
      if (e.key !== 'Tab') return;
      var f = $$('a[href],button:not([disabled]),input,select', fl).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (doc.activeElement === first || doc.activeElement === fl)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    var ap = $('[data-cdu-apply]', fl); ap && ap.addEventListener('click', closeSheet);
    addEventListener('resize', function () { if (!phone() && fl.classList.contains('open')) closeSheet(); });
  }

  /* ---------- sticky bar sits under the sticky header ---------- */
  function stick() {
    var h = $('.hdr'), top = 0;
    if (h) { var cs = getComputedStyle(h); if (cs.position === 'sticky' || cs.position === 'fixed') top = Math.max(0, Math.round((parseFloat(cs.top) || 0) + h.offsetHeight)); }
    html.style.setProperty('--cdu-stick', top + 'px');
  }
  stick(); addEventListener('resize', stick); addEventListener('load', stick);
  if (window.ResizeObserver && $('.hdr')) new ResizeObserver(stick).observe($('.hdr'));

  /* ---------- loading: skeleton cards while the next page or the car's parts load ---------- */
  function loading() {
    var g = $('#results'); if (!g || g.classList.contains('cdu-is-loading') || !CDU.skeleton) return;
    var n = Math.min(8, Math.max(4, $$('.card', g).length));
    g.classList.add('cdu-is-loading'); CDU.skeleton.cards(g, n);
  }
  function unload() { var g = $('#results'); if (g && g.classList.contains('cdu-is-loading')) { CDU.skeleton.clear(g); g.classList.remove('cdu-is-loading'); } }
  addEventListener('pageshow', function (e) { if (e.persisted) unload(); });
  doc.addEventListener('change', function (e) { if (e.target.id === 'sort' && root && !root.classList.contains('was-car') && !root.classList.contains('is-car')) loading(); });
  doc.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
    var a = e.target.closest && e.target.closest('#c-part a.chip[href], .pager a[href]');
    if (a && root && !root.classList.contains('was-car')) loading();
  });

  /* ---------- start ---------- */
  function start() {
    renderHead(); renderActive();
    priceApplied = priceLabel(); renderActive();
    var cp = $('#c-part'), bc = $('#b-car'), ct = $('#count'), pf = $('#b-price');
    var mo = new MutationObserver(soon);
    cp && mo.observe(cp, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
    bc && mo.observe(bc, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-pressed'] });
    ct && mo.observe(ct, { childList: true, characterData: true, subtree: true });
    pf && pf.addEventListener('submit', function () { setTimeout(function () { priceApplied = priceLabel(); renderActive(); }, 0); });
  }
  window.addEventListener('cdx-car', renderHead);
  window.addEventListener('storage', function (e) { if (e.key === 'cdx-car') renderHead(); });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
  addEventListener('load', renderHead);
})();
